interface LoadBoardCellProps {
  boards: string[]
}

export function LoadBoardCell({ boards }: LoadBoardCellProps) {
  return (
    <div className="flex flex-col items-start">
      <div className="flex h-7 items-center gap-1">
        {boards.map((board) => (
          <span
            key={board}
            className="flex items-center justify-center rounded border border-gray-200 px-1.5 py-0.5 text-xs text-gray-500"
          >
            {board}
          </span>
        ))}
      </div>
      <div className="h-7" />
    </div>
  )
}
